import { getApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { useHttpsCallable as useHttpsCallableBase } from 'react-firebase-hooks/functions';

const REGION = 'europe-west3';

export const useHttpsCallable = <T>(name: string) =>
  useHttpsCallableBase<unknown, T>(getFunctions(getApp(), REGION), name);
